export function growtypeForm() {
    $('.b-audio').click(function () {
        if ($(this).closest('.b-audio-wrapper').hasClass('is-active')) {
            $('.b-audio-wrapper').removeClass('is-active');
            $('.b-audio-wrapper').find('input[type="checkbox"]').attr('checked', false);
        } else {
            $('.b-audio-wrapper').removeClass('is-active');
            $('.b-audio-wrapper').find('input[type="checkbox"]').attr('checked', false);
            $(this).closest('.b-audio-wrapper').addClass('is-active');
            $(this).closest('.b-audio-wrapper').find('input[type="checkbox"]').attr('checked', true);
        }
    });

    /**
     * Image uploading extended
     */
    // $(document).on('imageUploader:createImg', function (e, $imgContainer, src, id, preloaded, plugin) {
    //
    //     if ($imgContainer.find('.featured-checkbox').length) return;
    //
    //     let $checkboxContainer = $('<div>', {class: 'featured-checkbox', style: 'margin-top:5px;'});
    //     let $checkbox = $('<input>', {
    //         type: 'checkbox',
    //         name: 'featured_images[]',
    //         value: id
    //     }).appendTo($checkboxContainer);
    //     $('<label>', {text: 'Featured'}).appendTo($checkboxContainer);
    //
    //     // Stop propagation only for the label click, allow checkbox toggle
    //     $checkbox.on('click', function(e){
    //         e.stopPropagation(); // allow checking/unchecking
    //     });
    //
    //     $imgContainer.append($checkboxContainer);
    //
    //     // Optional: mark preloaded images
    //     if (preloaded && plugin.settings.filters && plugin.settings.filters.featured_ids) {
    //         if (plugin.settings.filters.featured_ids.includes(id)) {
    //             $checkbox.prop('checked', true);
    //         }
    //     }
    // });
}
